import { DefaultBox } from '../../etc/LBox/LBox';
import { Button } from 'oui';
import useToast from '../../../application/hooks/useToast';

const Ui = () => {
  const { addToast } = useToast();
  const handleOpenToast = () => {
    addToast('PASS 앱 업데이트가 필요해요');
  };

  return (
    <DefaultBox>
      <h1>Global Toast Test</h1>
      <Button
        onClick={handleOpenToast}
        flexible={true}
        configuration={'contained'}
      >
        show toast
      </Button>
      <br />
      <h1>OUI component test</h1>
      <Button flexible={true} configuration={'contained'} children={'Button'} />
    </DefaultBox>
  );
};

export default Ui;
